import Grid from "@mui/material/Grid";
import PropTypes from "prop-types";

import MKBox from "components/MKBox";
import CircularPhotoCard from "reusables/Cards/CircularPhotoCard";
import SectionLayout from "reusables/layouts/SectionLayout";

function HowItWorks({ title, description, steps }) {
  return (
    <SectionLayout
      title={title}
      description={description}
      contents={
        <MKBox mt={5}>
          <Grid container spacing={3}>
            {steps.map((step, index) => (
              <Grid key={index} item xs={12} lg={4}>
                <MKBox mb={1}>
                  <CircularPhotoCard
                    image={step.image}
                    icon="check"
                    name={step.name}
                    position={{ color: "text", label: step.label }}
                  />
                </MKBox>
              </Grid>
            ))}
          </Grid>
        </MKBox>
      }
    />
  );
}

HowItWorks.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  steps: PropTypes.arrayOf(
    PropTypes.shape({
      image: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    })
  ).isRequired,
};

export default HowItWorks;
